import { ArtistGenreUnionType, useUpdateArtist } from '@api';
import { useNotification } from '@common';
import { AxiosError } from 'axios';
import { EditArtistFormSchemaType } from '../useEditArtistForm';

const TRANS_KEY = 'NOTIFICATIONS.UPDATE_ARTIST';

type UseSubmitUpdateArtistReturnType = {
  submitUpdateArtist: (data: EditArtistFormSchemaType) => Promise<void>;
};

export const useSubmitUpdateArtist = (
  artistId: string
): UseSubmitUpdateArtistReturnType => {
  const { mutateAsync: updateArtist } = useUpdateArtist();
  const { showSuccess, showError } = useNotification();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_KEY}.SUCCESS.TITLE`,
      message: `${TRANS_KEY}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_KEY}.ERROR.TITLE`,
      message: `${TRANS_KEY}.ERROR.MESSAGE`,
      error,
    });
  };

  const submitUpdateArtist = async (
    data: EditArtistFormSchemaType
  ): Promise<void> => {
    await updateArtist(
      {
        artistId,
        data: {
          name: data.name,
          abbreviation: data.abbreviation,
          artistLink: data.artistLink,
          website: data.website,
          genre: data.genres as ArtistGenreUnionType[],
          isDomesticArtist: data.isDomesticArtist,
          isFemaleAct: data.isFemaleAct,
          comment: data.comment,
          organizationUnit: data.organizationUnit,
        },
      },
      { onSuccess, onError }
    );
  };

  return { submitUpdateArtist };
};
